import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["perPage"]

  sync(event) {
    if (event.target.name !== "per_page") return

    this.perPageTarget.value = event.target.value
  }
}
